import React from 'react';
import { Content, Page } from '@backstage/core-components';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import {
  Grid,
  Card,
  styledComponent,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';
import { HomeHeader } from './HomeHeader';
import { TasksAndRegistrations } from './TasksAndRegistrations';
import AgendaAndQuickLinks from './AgendaAndQuicklinks';
import { OpenBugs } from '@dewise-devex/backstage-plugin-product-work-item';
import { usePermission } from '@backstage/plugin-permission-react';
import { defaultLandingReadPermission } from '@dewise-devex/backstage-plugin-utilities-common';

const Container = styledComponent(Card)(() => ({
  flexGrow: 1,
  margin: '0 2.3em',
  overflow: 'unset',
  '& main': {
    height: 'auto',
    overflowY: 'hidden',
  },
}));

const HomePageContent = () => {
  const { loading: loadingPermission, allowed: canView } = usePermission({
    permission: defaultLandingReadPermission,
  });

  let defaultContent = (
    <Grid
      container
      size={{ sm: 12, xs: 12, md: 12 }}
      spacing={2}
      sx={{ my: 3, mx: 2 }}
    >
      <HomeHeader />
      <Grid size={{ sm: 12, xs: 12, md: 12 }}>
        <OpenBugs />
      </Grid>
      <TasksAndRegistrations />
      <AgendaAndQuickLinks />
    </Grid>
  );

  if (!canView) {
    defaultContent = <h1>This is the Customer Dashboard</h1>;
  }

  return <>{!loadingPermission && defaultContent}</>;
};

export const HomePage: React.FC = () => {
  return (
    <Container>
      <SearchContextProvider>
        <Page themeId="home">
          <Content>
            <HomePageContent />
          </Content>
        </Page>
      </SearchContextProvider>
    </Container>
  );
};
